/**
 * FlightView-Modus: Eintritt und Austritt mit sanfter Transition.
 */
import type { Camera } from '../renderer/Camera';
import type { CameraConfig } from '../config/CameraConfig';
import type { CameraTransition } from './CameraTransition';
import type { EventBus } from '../core/EventBus';
import { pitchForMode } from './CameraPitch';
import { CameraMode } from './CameraMode';

export interface FlightViewController {
  readonly _camera: Camera;
  readonly _config: CameraConfig;
  readonly _trans: CameraTransition;
  readonly _events: EventBus;
  _mode: CameraMode;
  _zoom: number;
  _zoomTarget: number;
  _savedZoom: number;
  _savedTargetX: number;
  _savedTargetZ: number;
  _yaw: number;
}

export function enterFlightView(ctrl: FlightViewController): void {
  if (ctrl._mode === CameraMode.FlightView) return;
  const sp = pitchForMode(CameraMode.Free, ctrl._zoom, ctrl._config);
  ctrl._savedZoom = ctrl._zoomTarget;
  ctrl._savedTargetX = ctrl._camera.target.x;
  ctrl._savedTargetZ = ctrl._camera.target.z;
  ctrl._mode = CameraMode.FlightView;
  ctrl._zoomTarget = ctrl._config.flightView.zoomDefault;
  const ep = pitchForMode(CameraMode.FlightView, ctrl._zoomTarget, ctrl._config);
  ctrl._yaw = 0;
  ctrl._trans.begin(ctrl._camera, ctrl._zoom, sp, ep);
  ctrl._events.emit('camera:mode-changed', { mode: ctrl._mode });
}

export function exitFlightView(ctrl: FlightViewController): void {
  if (ctrl._mode !== CameraMode.FlightView) return;
  const sp = pitchForMode(CameraMode.FlightView, ctrl._zoom, ctrl._config);
  ctrl._mode = CameraMode.Free;
  ctrl._zoomTarget = ctrl._savedZoom;
  const ep = pitchForMode(CameraMode.Free, ctrl._zoomTarget, ctrl._config);
  ctrl._yaw = 0;
  ctrl._trans.begin(ctrl._camera, ctrl._zoom, sp, ep);
  ctrl._events.emit('camera:mode-changed', { mode: ctrl._mode });
}
